import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import {
  ISpecificationFolderGetRequest,
  ISpecificationFolderDetailGetRequest,
  ISpecificationFolderCreateRequest,
  ISpecificationFolderUpdateRequest,
  ISpecificationFolderDeleteRequest,
  ISpecificationFolderMoveRequest,
  ISpecificationFolderOrderRequest,
  ISpecificationFolderListRequest,
  ISpecificationFolderBulkDeleteRequest,
} from "../interface/requests/ISpecificationFolderRequest";
import {
  ISpecificationFolderDetailGetResponse,
  ISpecificationFolderCreateResponse,
  ISpecificationFolderUpdateResponse,
  ISpecificationFolderDeleteResponse,
  ISpecificationFolderMoveResponse,
  ISpecificationFolderOrderResponse,
  ISpecificationFolderListResponse,
  ISpecificationFolderGetListResponse,
  ISpecificationFolderBulkDeleteResponse,
} from "../interface/responses/ISpecifciationFolderResponses";

class SpecificationFolderService {
  constructor() {}

  async getSpecificationFolders(data: ISpecificationFolderGetRequest) {
    const queryParams = new URLSearchParams();
    if (data.offset != undefined || data.offset != null)
      queryParams.append("offset", data.offset.toString());
    if (data.limit != undefined || data.limit != null)
      queryParams.append("limit", data.limit.toString());
    if (data.sortBy != undefined || data.sortBy != null)
      queryParams.append("sortBy", data.sortBy);
    const response = await httpClient.get<ISpecificationFolderGetListResponse>(
      API_ROUTES.SpecificationFolder.get(data.companyId) +
        `?${queryParams.toString()}`
    );
    return response as unknown as ISpecificationFolderGetListResponse;
  }

  async getSpecificationFolderDetail(
    data: ISpecificationFolderDetailGetRequest
  ) {
    const response =
      await httpClient.get<ISpecificationFolderDetailGetResponse>(
        API_ROUTES.SpecificationFolder.detail(data.folderId)
      );
    return response;
  }

  async createSpecificationFolder(data: ISpecificationFolderCreateRequest) {
    const response = await httpClient.post<ISpecificationFolderCreateResponse>(
      API_ROUTES.SpecificationFolder.create,
      data
    );
    return response;
  }

  async updateSpecificationFolder(data: ISpecificationFolderUpdateRequest) {
    const response = await httpClient.patch<ISpecificationFolderUpdateResponse>(
      API_ROUTES.SpecificationFolder.update(data.folderId),
      data
    );
    return response;
  }

  async deleteSpecificationFolder(data: ISpecificationFolderDeleteRequest) {
    const response =
      await httpClient.delete<ISpecificationFolderDeleteResponse>(
        API_ROUTES.SpecificationFolder.delete(data.folderId)
      );
    return response;
  }

  async moveSpecificationFolder(data: ISpecificationFolderMoveRequest) {
    const response = await httpClient.patch<ISpecificationFolderMoveResponse>(
      API_ROUTES.SpecificationFolder.move,
      data
    );
    return response;
  }

  async updateSpecificationFolderOrder(data: ISpecificationFolderOrderRequest) {
    const response = await httpClient.patch<ISpecificationFolderOrderResponse>(
      API_ROUTES.SpecificationFolder.order(data.companyId),
      data
    );
    return response;
  }

  async getSpecificationFolderList(data: ISpecificationFolderListRequest) {
    const response = await httpClient.get<ISpecificationFolderListResponse[]>(
      API_ROUTES.SpecificationFolder.list(data.companyId)
    );
    return response;
  }

  async bulkDeleteSpecificationFolders(
    data: ISpecificationFolderBulkDeleteRequest
  ) {
    const response =
      await httpClient.post<ISpecificationFolderBulkDeleteResponse>(
        API_ROUTES.SpecificationFolder.bulkDelete,
        data
      );
    return response;
  }
}

export const specificationFolderService = new SpecificationFolderService();
export default SpecificationFolderService;
